// Lib
import { classicFormat } from '@/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { INSTAGRAM } from '@/lib/socialProfile';

// Components
import { HalfBarLineChart } from '@/components/composite/Charts/HalfBarLineChart';

export const mentionsHistory = {
    title: 'chart.instagram.mentions_history',
    tooltip: 'chart.instagram.mentions_history_tooltip',
    id: 'mentions_history',
    margin: {
        left: -25,
        right: -25,
        bottom: 25,
        top: 10
    },
    name: {
        date: 'date',
        caption: 'chart.mentions_type_instagram.caption',
        comment: 'chart.mentions_type_instagram.comment',
        tag: 'chart.mentions_type_instagram.tag',
        total: 'total'
    },
    social: INSTAGRAM,
    valueFormat: classicFormat,
    orientation: 'horizontal',
    labelLeftAxis: 'followers',
    labelRightAxis: 'chart.post_engagements.posts',
    color: {
        caption: 'purple',
        comment: 'orange',
        tag: 'blue',
        total: 'gray'
    },
    legendTypes: {
        caption: 'square',
        comment: 'square',
        tag: 'square',
        total: 'line'
    },
    size: SIZE_50,
    type: 'chart',
    element: HalfBarLineChart
};
